import Dashboard from ".";
import CommonDashboard from "./CommonDashboard.js";

export const dashboardRoutes = (data) => [
  {
    path: "/admin",
    title: "dashboard",
    layout: "admin",
    routeType: "admin",
    component: Dashboard,
  },
  {
    path: "/admin/dashboard",
    title: "dashboard",
    layout: "admin",
    routeType: "admin",
    component: Dashboard,
  },
  {
    path: "/dashboard",
    title: "dashboard",
    layout: "admin",
    // routeType: "admin",
    component: CommonDashboard,
  },
];
